import React from 'react';
import { useIsMobile } from 'helpers/hooks';
import NativeSelect from './NativeSelect';
import CustomSelect from './CustomSelect';

// Expected Options Format:
// with and without icon
/*
{
  value: 
    label
    icon // fills into `assets/icons/${icon}.svg`
  },
  // OR:
  value: 
    label
  },
  // OR:
  value: label
]
*/

function Select(props) {
  const isMobile = useIsMobile();
  if (isMobile) return <NativeSelect {...props} />;
  return <CustomSelect {...props} />;
}

export default Select;
